import { Alert } from "antd";
import { Redemption } from "../../../api/redemption/Redemption";

interface DistributorManualFlowWarningProps {
  redemptions?: Redemption[];
}

export function hasDistributorOrder(redemptions: Redemption[] = []): boolean {
  return redemptions.some(({ DistributorId }) =>
    typeof DistributorId === "string" && DistributorId.trim().length > 0
  );
}

export default function DistributorManualFlowWarning({
  redemptions,
}: DistributorManualFlowWarningProps) {
  if (!hasDistributorOrder(redemptions)) {
    return null;
  }

  return (
    <Alert
      type="warning"
      showIcon
      message="Distributor order: manual plugin flow warning"
      description="Manual plugin-based flows are not currently supported for distributor orders with pre-reserved inventory. Continuing may bypass distributor inventory allocation and cause unexpected issues. Use the automated fulfilment flow where possible."
    />
  );
}
